import { geoFormModelToGeo, geoToGeoFormModel } from '../../../geo/components/form-geo-field/mappers';
import { Agency } from '../../../providers/api/dtos';
import { booleanStringToBool, boolToBooleanString } from '../../../utils/boolean-string/booleanString';
import { formatInputDate } from '../../../utils/form';
import { AgencyRegistryFormModel } from '../../components/agency-registry-form/AgencyRegistryForm';

export const agencyToAgencyRegistryFormModel = (agency: Agency): AgencyRegistryFormModel => ({
  name: agency.name,
  shortName: agency.shortName,
  phoneNumber: agency.phoneNumber || '',
  startDate: formatInputDate(new Date(agency.startDate)),
  address: geoToGeoFormModel(agency.address),
  openingHours: agency.openingHours?.join('\n') || '',
  isLuxury: boolToBooleanString(agency.luxury),
  isFranchising: boolToBooleanString(agency.franchising),
});

export const agencyRegistryFormModelToAgency = (agencyFormModel: AgencyRegistryFormModel, existingAgency: Agency): Agency => {
  const openingHours = agencyFormModel.openingHours
    .replace(/(^[ \t]*\n)/gm, '')
    .split('\n')
    .map((hour) => hour.replace(/\s+/g, ' ').trim())
    .filter(Boolean);

  return {
    ...existingAgency,
    name: agencyFormModel.name.trim(),
    shortName: agencyFormModel.shortName.trim(),
    phoneNumber: agencyFormModel.phoneNumber?.trim() || undefined,
    startDate: new Date(agencyFormModel.startDate).toISOString(),
    address: geoFormModelToGeo(agencyFormModel.address) || {},
    openingHours: openingHours.length ? openingHours : undefined,
    luxury: booleanStringToBool(agencyFormModel.isLuxury),
    franchising: booleanStringToBool(agencyFormModel.isFranchising),
  };
};
